import React from "react";
import googlePlay from "../../../../assets/img/GooglePlay.svg";
import BenefitsCard from "../components/BenefitsCard";
import { useHistory } from "react-router-dom";

import {
  TABLET_BASED_POS_CARDS,
  PRODUCT_MANAGEMENT_CARDS,
  BRANCH_MANAGEMENT_CARDS,
  REPORTS_AND_ANALYTICS_CARDS,
  GOOGLE_PLAY_URL,
} from "../../../../helpers/constants";
import { trackAppClick } from "../../../../helpers/analyticsTracking";

export default function BenefitsDetailPage({ state }) {
  const selectedLanguage = localStorage.getItem("language") || "English";

  const translateTitle = () => {
    if (state.tablet_based_pos) {
      if (selectedLanguage === "arabic") {
        return "برنامج نقاط البيع عبر الأجهزة اللوحية";
      }
      return "POS software via tablets";
    }
    if (state.product_management) {
      if (selectedLanguage === "arabic") {
        return "إدارة سلسة لعناصر المبيعات";
      }
      return "Seamless sales items management";
    }
    if (state.branch_management) {
      if (selectedLanguage === "arabic") {
        return "إدارة الفروع";
      }
      return "Branches Management";
    }
    if (state.reports_and_analytics) {
      if (selectedLanguage === "arabic") {
        return "تقارير وتحليلات مفصلة";
      }
      return "Detailed reports and analysis";
    }
  };
  const translateBottomText = () => {
    if (state.tablet_based_pos) {
      if (selectedLanguage === "arabic") {
        return "إبدأ رحلتك وجرب سهولة الفوترة الإلكترونية";
      }
      return "Start your journey and experience the ease of online invoicing";
    } else if (state.product_management) {
      if (selectedLanguage === "arabic") {
        return "إبدأ رحلتك وجرب سهولة إدارة العناصر";
      }
      return "Start your journey and experience the ease of managing items";
    } else if (state.branch_management) {
      if (selectedLanguage === "arabic") {
        return "إبدأ الآن وجرب سهولة إدارة الفروع";
      }
      return "Start now and experience the ease of managing branches";
    } else if (state.reports_and_analytics) {
      if (selectedLanguage === "arabic") {
        return "ابدأ الآن واطّلع على تحليلات وتقارير تمنحك رؤية أعمق";
      }
      return "Get started now and see analytics and reports that give you deeper visibility";
    }
  };

  let refactoredData = {
    title: translateTitle(),
    bottomText: translateBottomText(),
    data: state?.product_management
      ? PRODUCT_MANAGEMENT_CARDS
      : state?.branch_management
      ? BRANCH_MANAGEMENT_CARDS
      : state?.reports_and_analytics
      ? REPORTS_AND_ANALYTICS_CARDS
      : TABLET_BASED_POS_CARDS,
  };
  const history = useHistory();

  const handlePosDownloadClick = () => {
    trackAppClick();
  };
  return (
    <div className="benefits-wrapper">
      <div className="benefits-top-wrapper">
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
          <div className="top-bar">
            <div className=" heading">{`${selectedLanguage === "arabic" ? "حمّل تطبيق فاتورتي مجاناً" : "Download Footarati app for free"} `}</div>
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "2rem" }}>
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" onClick={handlePosDownloadClick}>
                <img src={googlePlay} alt="google" className="top-bar-img" />
              </a>
            </div>
            <div className=" bottom-text">{`${
              selectedLanguage === "arabic"
                ? "سواء كنت تملك فرع واحد أو فروع متعددة, بإمكانك الآن إستخدام تطبيق فاتورتي مجاناً"
                : "Whether you have one or multiple branches, you can now use Fatoraty app for free"
            } `}</div>
          </div>
        </div>
      </div>

      <div className="main-content-wrapper">
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
          <div className="heading text-center mt-5">{refactoredData?.title}</div>

          {/* //benefits card */}
          <div className="">
            {refactoredData?.data?.map((item, index) => {
              return (
                <>
                  <BenefitsCard item={item} index={index} />
                </>
              );
            })}
          </div>
        </div>
      </div>

      <div className="benefits-bottom-wrapper">
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
          <div>
            <div className="heading">{refactoredData?.bottomText}</div>
            <button onClick={() => history.push("/auth/registration")}>{`${
              selectedLanguage === "arabic" ? "جرب فاتورتي الآن" : "TRY FATORATY NOW"
            } `}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
